module.exports = __webpack_public_path__ + "static/microsoft-logo-3bc77fe034c8e61c269d0d1f2074eee7.png";